import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addMaterial } from "../../../store/actions"
import { useEffect } from "react"

const AddMaterialStandard = props => {
  const dispatch = useDispatch()
  document.title = "Add Material Standard"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      material_standard: "",
    },
    validationSchema: Yup.object({
      material_standard: Yup.string().required(
        "Please Enter Material Standard"
      ),
    }),
    onSubmit: values => {
      dispatch(addMaterial(values, props.history))
    },
  })

  const inco = useSelector(state => state.materialStandard)
  const { error } = useSelector(state => ({
    error: state.materialStandard.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Material Standard" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formMaterial"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="incoterm">
                            Material Standard
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="material_standard"
                            className={
                              validation.touched.material_standard &&
                              validation.errors.material_standard
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="material_standard"
                            placeholder="Enter Material Standard"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.material_standard || ""}
                          />
                          {validation.touched.material_standard &&
                          validation.errors.material_standard ? (
                            <FormFeedback type="invalid">
                              {validation.errors.material_standard}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {inco && inco.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddMaterialStandard
